import { formatDate } from './dateFormat';

// Same rule as the backend activeFilter(false): a patient is active unless block === true.
export const isInactivePatient = (patient) => patient?.block === true;

// Inactive-patient review and Reactivate: Super Admin + Org Manager only (server enforces too).
export const INACTIVE_REVIEW_ROLES = ['admin', 'adminStaff'];
export const canReviewInactive = (role) => INACTIVE_REVIEW_ROLES.includes(role);
export const canReactivatePatient = canReviewInactive;

// Dashboard counts are active-only; older servers only send the legacy keys.
export const activeDashboardStats = (payload = {}) => ({
    activePatients: payload.activePatients ?? payload.activePts ?? payload.totalPatients ?? 0,
    inactivePatients: payload.inactivePatients ?? payload.blockpts ?? 0,
    activePatientDevices: payload.activePatientDevices ?? payload.totalDevices ?? 0,
});

export const padCount = (n) => (n && n < 10 ? `0${n}` : n ?? 0);

export const describeDeactivation = (deactivation) => ({
    date: deactivation?.at ? formatDate(deactivation.at) : 'Not recorded',
    reason: deactivation?.reason || 'Not recorded',
    by: deactivation?.by || '',
});
